import BaseInput from "../../../baseComponents/baseInput.js";
import BaseButton from "../../../baseComponents/baseButton.js";
import { useRef, useEffect, useState } from "react";
import LoginTemplate from "../LoginTemplate.js";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { asyncActions as loginAsyncActions } from "../../../store/slices/loginSlice.js";

import { useNavigate } from "react-router-dom";

const ChangePasswordView = ({
  title,
  autoRelogin = false,
  afterLoginRoutesPath = [],
}) => {
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////dispatcher, navigator
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////refs
  const passwordRef = useRef();

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////reduxState

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////local state
  const [fattalErrorMsg, setFattalErrorMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////input states
  const [passwordInput, setPasswordInput] = useState("");
  const [confirmPasswordInput, setConfirmPasswordInput] = useState("");

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////handling input functions
  const handlePassword = (e) => {
    clearError();
    setPasswordInput(e.target.value);
  };
  const handleConfirmPassword = (e) => {
    clearError();
    setConfirmPasswordInput(e.target.value);
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////methods
  const canChangePassword = async (pPromiseFromRedux) => {
    try {
      const res = await pPromiseFromRedux;
      if (res.error?.name !== "AbortError") {
        const parsedRes = JSON.parse(res.payload.P_RESULT);
        if (parsedRes.isSuccess === false) {
          setFattalErrorMsg("changePasswordFatalError");
          return false;
        }
        return true;
      }
    } catch (err) {
      setFattalErrorMsg("changePasswordFatalError");
      return false;
    }
  };

  const changePassword = async () => {
    const canAskPromise = dispatch(
      loginAsyncActions.canChangePassword({ pMail: email, pToken: token, pUserIdentifier: email, pMethod: "E" })
    );
    const canAskResult = await canChangePassword(canAskPromise);

    if (canAskResult === true) {
      const res = await dispatch(
        loginAsyncActions.changePassword({
          pMethod: "E",
          pUserIdentifier: email,
          pToken: token,
          password: passwordInput,
          confirmPassword: confirmPasswordInput,
          navigate: navigate,
          setErrorMsg: setErrorMsg,
        })
      );
    }
  };

  const clearError = () => {
    setErrorMsg("");
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////params from URL
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////effects

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////ask if can change password
  useEffect(() => {
    const resPromise = dispatch(
      loginAsyncActions.canChangePassword({ pMail: email, pToken: token, pUserIdentifier: email, pMethod: "E" })
    );
    canChangePassword(resPromise);

    return () => {
      resPromise.abort();
    };
  }, []);

  if (fattalErrorMsg) {
    return <LoginTemplate error={fattalErrorMsg} />;
  }

  return (
    <LoginTemplate
      heading={title}
      onEnter={changePassword}
      focusElement={passwordRef}
      autoRelogin={autoRelogin}
      afterLoginRoutesPath={afterLoginRoutesPath}
    >
      <>
        <BaseInput
          type="password"
          placeholder="password"
          innerRef={passwordRef}
          value={passwordInput}
          onChange={handlePassword}
        />
        <BaseInput
          type="password"
          placeholder="repeatNewPassword"
          value={confirmPasswordInput}
          onChange={handleConfirmPassword}
        />
        {
          <BaseButton error={errorMsg} onClick={changePassword}>
            save
          </BaseButton>
        }
      </>
    </LoginTemplate>
  );
};

export default ChangePasswordView;

//forgotPasswordTitle
